module.exports = __webpack_public_path__ + "static/undirected-graph-multiple-edge-e984aa53bbce19e64d90eb46a0f7193c.svg";